module.exports = __webpack_public_path__ + "img/apartments-icon.671f07de.svg";